export default __webpack_public_path__ + "static/media/forced.be20cba5.svg";